import NiceModal from "@ebay/nice-modal-react";
import Dummy from "components/Dummy";
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { AuthReducer } from "shared/redux/reducers/auth/AuthReducer";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { SearchConditionReducer } from "shared/redux/reducers/product/SearchConditionReducer";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import { DirectPurchaseReducer } from "shared/redux/reducers/shopping/DirectPurchaseReducer";
import { OrderInfoReducer } from "shared/redux/reducers/shopping/OrderInfoReducer";
import { PointReducer } from "shared/redux/reducers/shopping/PointReducer";
import { WishReducer } from "shared/redux/reducers/shopping/WishReducer";
import { VendorReducer } from "shared/redux/reducers/vendor/VendorReducer";
import { removeLocalStorage } from "shared/utils/Utils";

function MobileSetting() {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isMobile } = useContext(BrowserDetectContext);

    const onSignoutClick = () => {
        NiceModal.show("logout", {
            message: t("confirmLogout"),
            confirmText: t("confirm"),
            cancelText: t("cancel"),
            onConfirm: onConfirm,
            onCancel: onCancel
        });
    }

    const onConfirm = () => {
        removeLocalStorage("token");
        dispatch(AuthReducer.actions.reset());
        dispatch(CartReducer.actions.reset());
        dispatch(OrderInfoReducer.actions.reset());
        dispatch(WishReducer.actions.reset());
        dispatch(DirectPurchaseReducer.actions.reset());
        dispatch(SearchConditionReducer.actions.reset());
        dispatch(HistoryReducer.actions.reset());
        dispatch(VendorReducer.actions.reset());
        dispatch(PointReducer.actions.reset());
        window.location.replace(`/ws/${id}/mobile`);
    }

    const onCancel = () => {

    }
    const onWithdrawalClick = () => {
        navigate(`/ws/${id}/mobile/withdrawal`)
    }
    return (
        <Container height={"90vh"} backgroundColor={""}>
            <VerticalFlex>
                <FlexChild height={"max-content"} padding={10}>
                    <div onClick={onSignoutClick} style={{display: "flex",justifyContent: "center", cursor: "pointer"}}>
                        <P weight={"bold"}>로그아웃</P>
                    </div>
                </FlexChild>
                <FlexChild height={"1.5px"} backgroundColor={"#ddd"} />
                <FlexChild padding={10}>
                    <div onClick={onWithdrawalClick} style={{display: "flex",justifyContent: "center", cursor: "pointer"}}>
                        <P weight={"bold"}>회원탈퇴</P>
                    </div>
                </FlexChild>


            </VerticalFlex>
        </Container>
    );
}

export default MobileSetting;